import React from 'react';
import styled from 'styled-components';
import { Button, Buttons, CancelButton, FormMessage, ModalCard } from '~/components';
import { useApi } from '~/contexts';
import { useForm } from '~/hooks';
import { weights } from '~/styles';

const Name = styled.p`
  margin-bottom: 1rem;

  > span {
    font-weight: ${weights.bold};
  }
`;

const Description = styled.p`
  line-height: 1.5;
`;

export default function CreateInvoiceSubscription({ workspace, onChange, onClose }) {
  const [{ isSubmitting, message, status }, form] = useForm();
  const api = useApi();

  const handleSubmit = async (scope) => {
    form.submit(scope);

    try {
      await api.admin.workspaces.subscribe(workspace.id);

      onChange();
      onClose();
      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  };

  return (
    <ModalCard title="Create Invoice Subscription" onClose={onClose}>
      <ModalCard.Body>
        {status && <FormMessage.Error style={{ marginBottom: '1rem' }}>{message}</FormMessage.Error>}
        <Name>
          <span>{workspace.name}</span> ({workspace.key})
        </Name>
        <Description>
          This will create a Stripe subscription with invoice payments on net-30 payment terms. The workspace will be
          billed via invoice rather than automatic credit card charges. If the workspace is currently on an internal
          trial, the remaining trial period will be transferred to Stripe. Otherwise, billing will begin immediately.
        </Description>
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <Button isLoading={isSubmitting} onClick={handleSubmit}>
            Create Invoice Subscription
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
